export default {
  cs: {
    Home: {
      record: 'Rekord',
      singlePlayer: 'Hrát sám',
      about: 'O HŘE',
      aboutDescription: 'Geoguess Master je jednoduchá geoguess hra zdarma a bez reklam. \
        Hráči jsou umístěni na náhodné místo na světě a musí se pokusit podle svého okolí uhádnout, kde se nachází na mapě. \
        Hra se skládá z pěti kol. \
        Své skóre můžeš sdílet s ostatními na sociálních sítích Facebook a Twitter. \
        Můžeš hrát sám, nebo s dalšími až pěti kamarády. \
        Při hře více hráčů vytvoří jeden hráč místnost, do které se ostatní hráči připojí, aby mohli hrát spolu. ',
      limitation: 'OMEZENÍ',
      limitationDescription: "Tato hra má nastavená omezení počtu her za den, abych snížil náklady na provoz. \
        Pokud se mapa nenačítá, nebo se načte v režimu negativu (špatné barvy), znamená to, že dnešení limit her byl již naplněn. \
        Limit se resetuje o půlnoci amerického času (Pacific Time - tj. v 8 hodin ráno našeho zimního času, popř. 9 hodin ráno našeho letního času). Za tuto nepříjemnost se omlouvám. \
        Hra je poskytována open source, takže je možné hostovat vlastní kopii a hrát bez jakýchkoliv denních omezení.",
    },
    StreetViewWithFriends: {
      waitForOtherPlayers: 'Čekám na ostatní hráče...',
      redirectToHomePage: 'Přesměruji na úvodní stránku...',
      exitGame: 'Byl jsi přinucen ukončit hru (jeden z hráčů pravděpodovně odešel). Za 5 sekund přesměruji na úvodní stranu...',
      waitForOtherPlayersToFinish: 'Počkej prosím, až ostatní hráči dokončí hru...',
    },
    Maps: {
      makeGuess: 'HÁDEJ POLOHU',
      guess: 'POTVRDIT',
      nextRound: 'DALŠÍ KOLO',
      viewSummary: 'ZOBRAZ VÝSLEDKY',
    },
    MapsWithFriends: {
      makeGuess: 'HÁDEJ POLOHU',
      guess: 'POTVRDIT',
      nextRound: 'DALŠÍ KOLO',
      viewSummary: 'ZOBRAZ VÝSLEDKY',
    },
    Header: {
      language: 'Jazyk',
      about: 'O hře',
      limitation: 'Omezení',
      contact: 'Kontakt',
    },
    HeaderGame: {
      round: 'KOLO',
      score: 'SKÓRE',
    },
    CardRoomName: {
      title: 'Napiš název mísnosti',
      next: 'DALŠÍ',
      cancel: 'ZRUŠIT',
    },
    CardRoomPlayerName: {
      title: 'Jak se chceš jmenovat?',
      next: 'DALŠÍ',
      cancel: 'ZRUŠIT',
    },
    CardRoomSize: {
      title: 'Zvol počet hráčů.',
      next: 'DALŠÍ',
      cancel: 'ZRUŠIT',
    },
    CardRoomTime: {
      title: 'Zvol časové omezení kola.',
      next: 'DALŠÍ',
      cancel: 'ZRUŠIT',
      infinite: 'Bez omezení',
    },
    DialogRoom: {
      withFriends: 'Více Hráčů',
      invalidRoomName: 'Neplatné jméno, zvol prosím jiné.',
      inProgress: 'Správce místnosti právě vytvráří novou hru. Počkej prosím chvilku a pak to zkus znovu.',
      roomIsFull: 'Tato místnost je již plná. Počkej prosím chvíli a pak to zkus znovu.',
    },
    DialogSummary: {
      exit: 'UKONČIT',
      playAgain: 'HRÁT ZNOVU',
    },
    DialogSummaryWithFriends: {
      exit: 'UKONČIT',
    },
    Footer: {
      privacyPolicy: 'Zásady ochrany osobních údajů',
    },
  }
}
